import type { Collection } from '../../../collection'
import type * as ecModels from '../../../models'
import type * as plugin from '../../plugin'

import type { Config } from './config'
import { Plugin } from './plugin'

/**
 * {@link plugin.Plugin.Factory} for this {@link Plugin}
 * ({@link plugin.Plugin.Id.Standard.Group})
 */
export class Factory<TTypeParams extends ecModels.TypeParams.Constraint>
  implements
    plugin.Plugin.Factory<
      TTypeParams,
      plugin.Plugin.Id.Standard.Group,
      Plugin<TTypeParams>
    >
{
  /** @see {@link plugin.Plugin.Factory.id} */
  public readonly id = Plugin.Id.Standard.Group

  constructor(private readonly _config: Config.Options<TTypeParams> = {}) {}

  /** @see {@link plugin.Plugin.Factory.produceFor} */
  public produceFor(collection: Collection<TTypeParams>): Plugin<TTypeParams> {
    return new Plugin({ collection, config: this._config })
  }
}
